import { useCallback } from 'react';
import gun from '../config/gun.config';

const NOTIFY_URL = '/notify';

// Fetch a user's wallet address from GUN (needed for World App push notifications)
function getWalletAddress(nullifierHash: string): Promise<string | null> {
  return new Promise(resolve => {
    const t = setTimeout(() => resolve(null), 2000);
    gun.get('stabeon_users').get(nullifierHash).get('walletAddress').once((addr: any) => {
      clearTimeout(t);
      resolve(typeof addr === 'string' && addr.startsWith('0x') ? addr : null);
    });
  });
}

export function usePushNotify() {
  const push = useCallback(async (
    nullifierHashes: string[],
    title: string,
    message: string,
    path?: string,
  ): Promise<void> => {
    if (!nullifierHashes.length) return;

    // Resolve wallet addresses from GUN
    const addrs = await Promise.all(nullifierHashes.map(getWalletAddress));
    const walletAddresses = addrs.filter(Boolean) as string[];
    if (!walletAddresses.length) return;

    try {
      await fetch(NOTIFY_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ walletAddresses, title, message, ...(path ? { path } : {}) }),
      });
    } catch {
      // Best-effort — don't break the app if notifications fail
    }
  }, []);

  return { push };
}
